import React, {useLayoutEffect, useMemo} from "react";
import Header from "../../components/Header";
import "./style.scss";
import {observer} from "mobx-react";
import orderStore from "../../stores/order";
import {getCurrency, getHost} from "../../helpers/ApiHelper";
import defaultImg from "../../assets/images/default.webp";
import {
    getAdditionalSellUnitForOrderLine,
    getAddonsFromOrderLine,
    getIngredientsFromOrderLine,
    getModifiersFromOrderLine
} from "../../helpers/orderHelper";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import OrderIdle from "../../components/OrderIdle";
import IconNotSelected from "../../assets/images/notSelected.png";
import {ReactComponent as IconWarning} from "../../assets/icons/warning.svg";
import useLayoutStyles from "../../hooks/styles";
import menuStore from "../../stores/menu";
import FooterForInfoHalfAndHalf from "../../components/FooterForInfoHalfAndHalf";

const HalfAndHalfInfoPage = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    useLayoutEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (menuStore.selectedHalfAndHalfStep !== 2 || menuStore.selectedHalfAndHalfItems.filter(x => !!x).length < 2) {
            navigate("/menu");
            return;
        }
    }

    const changeStepArticle = (step: number) => {
        menuStore.selectedHalfAndHalfItems[step] = null;
        menuStore.selectedHalfAndHalfStep = step;
        navigate(`/menu/halfAndHalf/${menuStore.halfAndHalfNavigation.category}/${menuStore.halfAndHalfNavigation.subCategory}`);
    }

    const price = useMemo((): number => {
        let price = 0;
        let extraPrices = 0;
        for (let i = 0; i < menuStore.selectedHalfAndHalfItems.length; i++) {
            const item = menuStore.selectedHalfAndHalfItems[i];
            if (item) {
                const linePrice = item.price;// + orderStore.getExtraPriceFromOrderLine(item); - correct logic is compare item unit prices, after that add extra prices to total
                price = price < linePrice ? linePrice : price;

                extraPrices += orderStore.getExtraPriceFromOrderLine(item);
            }
        }

        return price + extraPrices;
    }, [menuStore.selectedHalfAndHalfItems]);

    return <div className="HalfAndHalfInfoPage">
        <Header/>
        <div className="content">
            <h2>{t("halfNHalf.title")}</h2>
            <div className="totalPrice">{(price).toFixed(2)} {getCurrency()}</div>
            <div className="orderLines">
                {menuStore.selectedHalfAndHalfItems.map((x, step) =>
                    x
                        ? <div key={`step_${x.id}`} className="step">
                            <div className="stepTitle">{x.name}</div>
                            <div key={`orderline_${x.id}`} className="orderLine">
                                <div className="img">
                                    {x.articleId !== -1
                                        ? <img alt={x.name} src={x.img ? `${getHost()}${x.img}` : (styles?.article.defaultListImage ? `${getHost()}${styles.article.defaultListImage}` : defaultImg)}/>
                                        : <img alt="not selected" src={IconNotSelected} />
                                    }
                                </div>
                                <div className="text">
                                    <div className="title">
                                        {x.articleId !== -1
                                            ? <>{x.count} x {x.name}</>
                                            : <>
                                                <div className="notSelected">{t("notSelected")}</div>
                                                <div className="noChoiceMade">
                                                    <IconWarning />
                                                    {t("noChoiceMade")}
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="details" key={x.id}>
                                        {[getAdditionalSellUnitForOrderLine(x)?.name || ""].filter(x => !!x).concat(getModifiersFromOrderLine(x).map(m => m.name), getAddonsFromOrderLine(x).map(a => a.name), getIngredientsFromOrderLine(x).map(a => a.name)).join(", ")}
                                    </div>
                                </div>
                                <div className="buttons">
                                    <div className="button" onClick={() => changeStepArticle(step)}>{t("change")}</div>
                                </div>
                            </div>
                        </div>
                    : null
                )}
            </div>
        </div>
        <FooterForInfoHalfAndHalf />
        <OrderIdle />
    </div>
}

export default observer(HalfAndHalfInfoPage);
